module.exports = __webpack_public_path__ + "static/media/oneDineLogo.ed1e5dc7.png";